export default "__VITE_ASSET__BBkT7PKl__"